import script from "./SortingVisualizer.vue?vue&type=script&setup=true&lang=js"
export * from "./SortingVisualizer.vue?vue&type=script&setup=true&lang=js"

import "./SortingVisualizer.vue?vue&type=style&index=0&id=7a74f83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a74f83e"]])

export default __exports__